/* eslint-disable no-undef */
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		CENTRA_CHECKOUT_SECRET: z.string().min(1),
		CENTRA_SHOP_SECRET: z.string().min(1),
		PREVIEW_TOKEN: z.string().min(1),
		REVALIDATE_SECRET: z.string().min(1),
		STORYBLOK_TOKEN: z.string().min(1),
		ADYEN_API_PREFIX: z.string().min(1),
		ADYEN_API_SECRET: z.string().min(1),
		YOTPO_API_KEY: z.string().min(1),
		YOTPO_API_KEY_NO: z.string().min(1).optional(),
		YOTPO_API_KEY_SE: z.string().min(1).optional(),
		YOTPO_API_KEY_DK: z.string().min(1).optional(),
		YOTPO_API_KEY_FI: z.string().min(1).optional(),
		YOTPO_API_KEY_DE: z.string().min(1).optional(),
		YOTPO_APP_KEY: z.string().min(1),
		YOTPO_APP_KEY_NO: z.string().min(1).optional(),
		YOTPO_APP_KEY_SE: z.string().min(1).optional(),
		YOTPO_APP_KEY_DK: z.string().min(1).optional(),
		YOTPO_APP_KEY_FI: z.string().min(1).optional(),
		YOTPO_APP_KEY_DE: z.string().min(1).optional(),
		YOTPO_CLIENT_SECRET: z.string().min(1),
		YOTPO_CLIENT_SECRET_NO: z.string().min(1).optional(),
		YOTPO_CLIENT_SECRET_SE: z.string().min(1).optional(),
		YOTPO_CLIENT_SECRET_DK: z.string().min(1).optional(),
		YOTPO_CLIENT_SECRET_FI: z.string().min(1).optional(),
		YOTPO_CLIENT_SECRET_DE: z.string().min(1).optional(),
		KLAVIYO_COMPANY_ID: z.string().min(1),
		KLAVIYO_PRIVATE_API_KEY: z.string().min(1),
		ORDER_API_KEY: z.string().min(1),
		LIPSCORE_API_KEY: z.string().optional(),
	},
	client: {
		NEXT_PUBLIC_YOTPO_GUID: z.string().min(1).optional(),
		NEXT_PUBLIC_YOTPO_GUID_NO: z.string().min(1).optional(),
		NEXT_PUBLIC_YOTPO_GUID_SE: z.string().min(1).optional(),
		NEXT_PUBLIC_YOTPO_GUID_DK: z.string().min(1).optional(),
		NEXT_PUBLIC_YOTPO_GUID_FI: z.string().min(1).optional(),
		NEXT_PUBLIC_YOTPO_GUID_DE: z.string().min(1).optional(),
		NEXT_PUBLIC_DEPICT_MERCHANT: z.string().min(1),
		NEXT_PUBLIC_CENTRA_CHECKOUT: z.string().url(),
		NEXT_PUBLIC_CENTRA_SHOP: z.string().url(),
		NEXT_PUBLIC_CENTRA_DOMAIN: z.string().min(1),
		NEXT_PUBLIC_GTM_ID: z.string().min(1),
		NEXT_PUBLIC_PROJECT: z.string().min(1),
		NEXT_PUBLIC_HYPERDX_KEY: z.string().min(1),
		NEXT_PUBLIC_ADDRESS_KEY: z.string().min(1),
		NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string().min(1),
		NEXT_PUBLIC_LIPSCORE_API: z.string().min(1).optional(),
		NEXT_PUBLIC_IS_STAGING: z.coerce.boolean().optional(),
		NEXT_PUBLIC_ORDER_API_URL: z.string().url(),
		NEXT_PUBLIC_ORDER_SYNC_URL: z.string().url(),
		NEXT_PUBLIC_VOLUMENTAL_CLIENT_ID: z.string().min(1).optional(),
	},
	experimental__runtimeEnv: {
		NEXT_PUBLIC_DEPICT_MERCHANT: process.env.NEXT_PUBLIC_DEPICT_MERCHANT,
		NEXT_PUBLIC_CENTRA_CHECKOUT: process.env.NEXT_PUBLIC_CENTRA_CHECKOUT,
		NEXT_PUBLIC_CENTRA_SHOP: process.env.NEXT_PUBLIC_CENTRA_SHOP,
		NEXT_PUBLIC_CENTRA_DOMAIN: process.env.NEXT_PUBLIC_CENTRA_DOMAIN,
		NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
		NEXT_PUBLIC_PROJECT: process.env.NEXT_PUBLIC_PROJECT,
		NEXT_PUBLIC_HYPERDX_KEY: process.env.NEXT_PUBLIC_HYPERDX_KEY,
		NEXT_PUBLIC_ADDRESS_KEY: process.env.NEXT_PUBLIC_ADDRESS_KEY,
		NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
		NEXT_PUBLIC_LIPSCORE_API: process.env.NEXT_PUBLIC_LIPSCORE_API,
		NEXT_PUBLIC_IS_STAGING: process.env.NEXT_PUBLIC_IS_STAGING,
		NEXT_PUBLIC_ORDER_API_URL: process.env.NEXT_PUBLIC_ORDER_API_URL,
		NEXT_PUBLIC_ORDER_SYNC_URL: process.env.NEXT_PUBLIC_ORDER_SYNC_URL,
		NEXT_PUBLIC_VOLUMENTAL_CLIENT_ID: process.env.NEXT_PUBLIC_VOLUMENTAL_CLIENT_ID,
		NEXT_PUBLIC_YOTPO_GUID: process.env.NEXT_PUBLIC_YOTPO_GUID,
		NEXT_PUBLIC_YOTPO_GUID_NO: process.env.NEXT_PUBLIC_YOTPO_GUID_NO,
		NEXT_PUBLIC_YOTPO_GUID_SE: process.env.NEXT_PUBLIC_YOTPO_GUID_SE,
		NEXT_PUBLIC_YOTPO_GUID_DK: process.env.NEXT_PUBLIC_YOTPO_GUID_DK,
		NEXT_PUBLIC_YOTPO_GUID_FI: process.env.NEXT_PUBLIC_YOTPO_GUID_FI,
		NEXT_PUBLIC_YOTPO_GUID_DE: process.env.NEXT_PUBLIC_YOTPO_GUID_DE,
	},
	onValidationError: (error) => {
		console.error(error);
		throw error;
	},
});
